<template>
  <div class="gap-x-2 my-2 w-full flex flex-wrap">
    <slot />
  </div>
</template>
